import { LOCATION_CHANGE } from "react-router-redux";
import browserHistory from "web_modules/redux/history";
import { getSessionToken, tokenHasRoles, checkAppRestricted } from "web_modules/shared/session";
import { Role } from "@eave/shared/types/api";

// eslint-disable-next-line consistent-return
const routeRoleApp = () => next => action => {
  if (action.type !== LOCATION_CHANGE || !getSessionToken()) {
    return next(action);
  }

  const {
    payload: { pathname },
  } = action;

  const found = pathname.match(/\/(underwriter|loan-officer)\/app\/([0-9]+)/);

  if (found) {
    const [, , appID] = found;
    if (tokenHasRoles(getSessionToken(), Role.CanViewRestricted)) {
      return next(action);
    }
    return checkAppRestricted(appID).then(appIsRestricted => {
      if (appIsRestricted) {
        browserHistory.push("/404");
      }
      return next(action);
    });
  }
  return next(action);
};

export default routeRoleApp;
